import React, { useState } from 'react';

import SearchFilterButton from '../../../common/SearchFilterButton';
import SearchFilterDrawer, {
  BaseSearchFilterProps
} from '../../../common/SearchFilterDrawer';
import { InlineFormControl } from '../../../common/inline/InlineFormControl';
import ChangeOrderStatusFilter from './ChangeOrderStatusFilter';

export interface ChangeOrderListFilterOptions {
  status: string[];
}

function createInitialOptions(): ChangeOrderListFilterOptions {
  return { status: [] };
}

export type ChangeOrderListFilterProps =
  BaseSearchFilterProps<ChangeOrderListFilterOptions>;

const ChangeOrderListFilter: React.FC<ChangeOrderListFilterProps> = (
  props: ChangeOrderListFilterProps
) => {
  const { onFilter } = props;
  const [open, setOpen] = useState<boolean>(false);
  const [options, setOptions] = useState<ChangeOrderListFilterOptions>(
    createInitialOptions()
  );

  const updateOptions = (
    updatedData: Partial<ChangeOrderListFilterOptions>
  ) => {
    setOptions({ ...options, ...updatedData });
  };

  return (
    <>
      <SearchFilterButton onClick={() => setOpen(true)} />
      <SearchFilterDrawer
        open={open}
        title='Filter Change Orders'
        onClose={() => setOpen(false)}
        onClear={() => setOptions(createInitialOptions())}
        onFilter={() => {
          setOpen(false);
          onFilter?.(options);
        }}
      >
        <InlineFormControl label='Status'>
          <ChangeOrderStatusFilter
            value={options.status}
            onChange={status => updateOptions({ status })}
          />
        </InlineFormControl>
      </SearchFilterDrawer>
    </>
  );
};

export default ChangeOrderListFilter;
